import React from 'react'
import Button from 'react-bootstrap/Button'
import LoadingSpinner from '../loadingSpiner'



const SubmitButton = (props)=>{
    return(
        <Button 
            className="model-submit-button"
            variant="success"
            onClick={props.submit}
            disabled={props.disabled}>
                {props.disabled ? 
                <div style={{
                    display: 'flex',
                    margin: 'auto',
                    marginLeft: '38%'
                }}>
                    <LoadingSpinner/>
                </div>
                 :
                <span>
                    {props.title}
                </span>
                }
        </Button>
    )
}

export default SubmitButton